import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import course05 from "../../../course/course-05/course";
import lesson0215 from "../../../lesson/course-02/lesson-15/lesson";
import lesson0219 from "../../../lesson/course-02/lesson-19/lesson";
import lesson0221 from "../../../lesson/course-02/lesson-21/lesson";
import lesson0508 from "../../../lesson/course-05/lesson-08/lesson";
import lesson0509 from "../../../lesson/course-05/lesson-09/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "676450a0-30c6-4d30-a15b-ad3ca1ac7cf0",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0215),
    lesson: lesson0215,
  },
  {
    id: "a760ad80-8009-42c8-a38b-33fa4be18394",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0219),
    lesson: lesson0219,
  },
  {
    id: "3438ac45-abf3-408e-9559-29718c807f1f",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0221),
    lesson: lesson0221,
  },
  {
    id: "89098a0d-99a4-4e89-9e15-7e47e3633eea",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0508),
    lesson: lesson0508,
  },
  {
    id: "2811203e-dce1-4e3b-91a7-4cefa30991c3",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0509),
    lesson: lesson0509,
  },
];

export default lessonLinks;
